// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"333":"b5c4811d","512":"10d44a1f"}[chunkId] + ".chunk.js";
};